import React, { Component } from 'react';

import { HashRouter as Router, Route, Switch } from 'react-router-dom'
import { Provider, observer } from 'mobx-react';

import membershipStore from '../../../stores/membershipStore';
import { textStore } from '../../../stores/textStore';
import { loadUserSubscriptions, syncUserSubscriptions, syncUserSubscriptionsMock, loadMemberships,
		loadPromotion} 
    from '../../../actions/membershipActions';
import { observable } from 'mobx';
    

class DataWrapper extends Component {	
	loadAllData = () => {			
		const querystring = new URLSearchParams(window.location.search);			
		/*if (querystring.get('trial_enabled') === 'on') {
			membershipStore.trialEnabled = true;
		}*/
		syncUserSubscriptions()
		//syncUserSubscriptionsMock()
		.then(json => {
			const context = window.tkcWidgetContext;
			membershipStore.multiCurrencyMode = context.multiCurrencyMode;	
			membershipStore.defactoCurrency = json.default_currency;
			if (membershipStore.multiCurrencyMode) {
				membershipStore.defactoCurrency = json.defacto_currency;					
			}
			membershipStore.balance = json.balance;
			membershipStore.storedCc = json.stored_cc;
			membershipStore.eligibleForTrial = json.eligible_for_trial;	
			if (context.promoCode) {
				membershipStore.promoCode.set(context.promoCode);
				loadPromotion();
			} else if (membershipStore.eligibleForTrial) {
				membershipStore.promoCode.set('X-M-FREE14D');
				loadPromotion();
			}
			/*if (window.location.hostname === 'localhost') {
				membershipStore.storedCc = {
					"ccnumber": "************1881",
					"ccexpiredate": "1/2020",
					"ccname": "Holdy Holderson",
					"ccdefault": "T",
					"paymentmethod": "VISA"
				};
			}*/
			loadMemberships()
			.then(() => {
				loadUserSubscriptions()
				.then(() => {
					const current = membershipStore.getCurrentUserSubscription();
					if (current.subscription.payment_frequency) {						
						membershipStore.changeForm.set('payment_frequency', 
								current.subscription.payment_frequency || 'annual');	
                    }	
                    membershipStore.reloadData.set(false);			
				})		
			})
		})
	}

	componentDidMount() {					
		this.loadAllData();				
	}	
		
	render() {
		return null;
	}
}

export default observer(DataWrapper);


// WEBPACK FOOTER //
// ./src/views/membership/components/DataWrapper.js